/**
 * Build-time configuration, resolved once so no component reads
 * `import.meta.env` directly.
 *
 * These were server-side env vars while the app was a Next server. They are now
 * baked into the bundle — which is fine for both of them (a hub URL and an API
 * path) and is why the session secret they used to sit next to no longer lives
 * in this app at all.
 */

const DEFAULT_HUB_URL = 'https://atelier.veevart.io';
const DEFAULT_API_URL = '/api';

const stripTrailingSlash = (url: string) => url.replace(/\/+$/, '');

/** Where to send someone who needs to sign in — the Atelier hub. */
export function atelierHubUrl(): string {
    return stripTrailingSlash(import.meta.env.VITE_ATELIER_URL?.trim() || DEFAULT_HUB_URL);
}

/**
 * Absolute-or-relative URL for a Backoffice API endpoint.
 *
 * Defaults to the same-origin `/api`, which is what makes the shared
 * `SameSite=Lax` cookie reach the API with no CORS: CloudFront routes `/api/*`
 * to Nest in production and Vite proxies it in dev.
 */
export function apiUrl(path: string): string {
    const base = stripTrailingSlash(import.meta.env.VITE_API_URL?.trim() || DEFAULT_API_URL);
    return `${base}${path.startsWith('/') ? path : `/${path}`}`;
}
